import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-solubility',
  templateUrl: './solubility.component.html',
  styleUrls: ['./solubility.component.css']
})
export class SolubilityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
